import { GetterTree } from 'vuex'

import { RootState, ItemState } from '@/types/store'

export const getters: GetterTree<ItemState, RootState> = {
  items(state): ItemState['items'] {
    return state.items
  },
  isItemsLoading(state): ItemState['isItemsLoading'] {
    return state.isItemsLoading
  },
  itemType(state): ItemState['itemType'] {
    return state.itemType
  },
}
